var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3093 5.78292C24.9952 6.46875 24.9952 7.58253 24.3093 8.26836L10.2636 22.3141C9.5778 22.9999 8.46402 22.9999 7.77819 22.3141L0.755336 15.2912C0.0695104 14.6054 0.0695104 13.4916 0.755336 12.8058C1.44116 12.12 2.55494 12.12 3.24077 12.8058L9.02365 18.5832L21.8294 5.78292C22.5152 5.0971 23.629 5.0971 24.3148 5.78292H24.3093Z",
    fill: "#6D1B6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.58,
    height: 28.0914,
    fill: "white",
    transform: "translate(0.245605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTitle);
export default __webpack_public_path__ + "static/media/check_title.9e3c9d4891adf6e702906d09966b296c.svg";
export { ForwardRef as ReactComponent };